import type { FC, MouseEvent } from 'react';

import { AddPersonIcon } from '@setup/svg-icons/svg-icons';
import { ShareUserButtonContainer } from '@shared/ui-kit/avatars/MuiAvatarGroup/components/ShareUserButton/ShareUserButton.style';

import type { AvatarSizeEnum } from '@shared/enums/avatarSize.enum';

type ShareUserButtonProps = {
  size: AvatarSizeEnum;
  isUsersListWithOwner: boolean;
  onClickShare?: () => void;
  classNameForTargetUserOnboardingTooltip?: string;
};

const ShareUserButton: FC<ShareUserButtonProps> = ({
  size,
  isUsersListWithOwner,
  onClickShare,
  classNameForTargetUserOnboardingTooltip,
}) => {
  return (
    <ShareUserButtonContainer
      id={'shareWithUsersBtn'}
      size={size}
      isUsersListWithOwner={isUsersListWithOwner}
      onClick={(e: MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
        onClickShare && onClickShare();
      }}
    >
      <AddPersonIcon className={classNameForTargetUserOnboardingTooltip} />
    </ShareUserButtonContainer>
  );
};

export default ShareUserButton;
